import { render, staticRenderFns } from "./Wyswygi.vue?vue&type=template&id=18cae78c&"
import script from "./Wyswygi.vue?vue&type=script&lang=js&"
export * from "./Wyswygi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports